export default "__VITE_ASSET__DOHCGaaT__"